import Vue from 'vue'
import TableHeader from './header.vue'

Vue.component('TableHeader', TableHeader)



// WEBPACK FOOTER //
// ./src/components/TableHeader/index.js